module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NCAzMiIgd2lkdGg9IjQ0IiBoZWlnaHQ9IjMyIj4NCiAgPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCiAgICAuYmxkci10b29sYmFyLWJ1cmdlci1pY29uIHsNCiAgICAgIGZpbGw6IzMyM0E0NTsNCiAgICB9DQogIDwvc3R5bGU+DQogIDxwYXRoIGNsYXNzPSJibGRyLXRvb2xiYXItbWVudS1pY29uIGJsZHItc3ZnLWljb24tcGF0aCIgZD0iTTAsMTRoMzJ2NEgwVjE0eiBNMCwwaDQ0djRIMFYweiBNMCwyOGg0MHY0SDBWMjh6Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/burger.svg
// module id = 9sUY
// module chunks = 0